<template>
  <div :id="id" :class="classes">
    <slot />
  </div>
</template>



<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },



  computed: {
    classes() {
      return {
        'dn-tabs__content': true,
        'dn-tabs__content--active': this.isActive,
      }
    },
    tabs() { return this.$parent.$parent },
    isActive() { return this.tabs.value === this.id },
  },
}
</script>


// WEBPACK FOOTER //
// TabsContent.vue?2b720384